export default "__VITE_ASSET__D4GiT$zQ__"